import * as React from "react";
import styles from '../styles/collectie.module.scss';
import { Stack, Callout, Label } from "@fluentui/react";
import { useBoolean, useId } from "@fluentui/react-hooks";
import GlobalContext from "../_contexts/GlobalContext";

export interface ILanguageFCProps {
    // eslint-disable-next-line
}

const LanguageFC: React.FunctionComponent<ILanguageFCProps> = (props: ILanguageFCProps) => {
    const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
    const buttonId = useId('callout-lang');

    const { SetLanguage, Strings, Refresh } = React.useContext(GlobalContext);

    return (
        <>
            <div className={`${Strings?.Products === "Products" ? styles.eng : styles.nl} ${styles.langComponent}`}
                id={buttonId}
                onMouseEnter={() => { !isCalloutVisible && toggleIsCalloutVisible(); }}
                onTouchStart={() => { !isCalloutVisible && toggleIsCalloutVisible(); }}
                onClick={() => {
                    SetLanguage("Nederlands");
                    Refresh();
                }}>
            </div>
            {isCalloutVisible && (
                <Callout
                    style={{ padding: 10 }}
                    role="dialog"
                    gapSpace={0}
                    target={`#${buttonId}`}
                    onMouseLeave={toggleIsCalloutVisible}
                    onDismiss={() => { toggleIsCalloutVisible(); }}
                    onMouseUp={() => {
                        setTimeout(() => {
                            toggleIsCalloutVisible();
                        }, 100);
                    }}
                    setInitialFocus
                >
                    <div>
                        <Stack horizontal className={styles.aPanel}>
                            <div className={styles.nl} onClick={() => { SetLanguage("Nederlands"); }}></div>
                            <Label style={{ marginTop: -3, marginLeft: 5, cursor: "pointer" }} onClick={() => { SetLanguage("Nederlands"); }}>Nederlands</Label>
                        </Stack>
                        <Stack horizontal style={{ marginTop: 5 }} className={styles.aPanel}>
                            <div className={styles.eng} onClick={() => { SetLanguage("English"); }}></div>
                            <Label style={{ marginTop: -3, marginLeft: 5, cursor: "pointer" }} onClick={() => { SetLanguage("English"); }}>English</Label>
                        </Stack>
                    </div>
                </Callout>
            )}
        </>
    );
}

export default LanguageFC;